import { FirebaseSubTasks } from './index'

const subTaskDb = () => {

  const findOne = taskId => {
    return FirebaseSubTasks.doc(taskId).get()
  }

  const findAll = () => {
    let query = FirebaseSubTasks.orderBy('title')
    return query
  }

  return Object.freeze({
    findOne,
    findAll
  })
}

const SubTasks = subTaskDb()

export { SubTasks }
